import React, { useState, useEffect } from 'react';
import { Row, Col, Button, Progress } from 'antd';
import Couples from '../../base/Couples';
import Result from '../../base/result';
import './index.less';
import { t } from '../../../languages';
import ExerciseBlocker from '../../Utils/ExerciseBlocker';
import moment from 'moment';
import BackMusic from '../../base/BackMusic';
import { getRandomMessage2 } from '../utils';

const CouplesChall = (props) => {
    const [state, setState] = useState({
        eid: 0,
        series: [],
        current: 0,
        results: [],
        times: [],
        message: null,
        message2: null,
        showresults: false,
        timeout: false,
        level: null,
    });

    const [initMoment, setInitMoment] = useState(0);

    useEffect(() => {
        setInitMoment(moment());
        return () => { };
    }, []);

    useEffect(() => {
        const params = props.params;
        const series = params ? params.levels : [];
        const level = series[0];

        setState({
            series,
            current: 0,
            results: [],
            times: [],
            message: null,
            message2: null,
            showresults: false,
            ready: false,
            timeout: false,
            level,
        });

        if (level) {
            setTimeout(() => {
                setState((prevState) => ({ ...prevState, timeout: true }));
            }, level.time * 1000);
        }
    }, [props.params]);

    const handleRate = (timereq) => {
        const { results, times } = state;
        const current_result = timereq;
        const message = `${t(props.lang, 'bravosur')}`;
        const message2 = current_result ? t(props.lang, getRandomMessage2('great')) : t(props.lang, getRandomMessage2('nodiscorage'));

        setState((prevState) => ({
            ...prevState,
            results: [...results, 1],
            times: [...times, current_result],
            message,
            message2,
        }));
    };

    const handleNext = () => {
        const { current, series } = state;

        if (current < series.length - 1) {
            const level = series[current + 1];

            setState((prevState) => ({
                ...prevState,
                current: current + 1,
                message: null,
                message2: null,
                ready: false,
                timeout: false,
                level,
            }));

            setTimeout(() => {
                setState((prevState) => ({ ...prevState, timeout: true }));
            }, level.time * 1000);
        } else {
            const { params, uid, eid, saveResult } = props;
            const num = params.num;
            const hits = state.results.reduce((acc, aR) => acc + aR, 0);
            const errors = num - hits;
            const passed = errors > params.errors ? 0 : 1;
            const coins = params.coins;
            const elapsedTime = moment().diff(initMoment, 'seconds');

            const totalTime = state.times.reduce((acc, aT) => acc + aT, 0);

            console.log('CouplesChall - elapsedTime:', elapsedTime);


            saveResult(
                uid,
                `${uid}-${eid}`,
                { id: 'CC', uid, eid, p: passed, h: hits, e: errors, c: passed ? coins : 0, t: totalTime, r: state.results, s: series, et: elapsedTime },
                state.times
            );

            setState((prevState) => ({
                ...prevState,
                showresults: true,
            }));
        }
    };

    const handleRepeat = () => {
        const params = props.params;
        const series = params ? params.levels : [];
        const level = series[0];

        setState({
            series,
            current: 0,
            results: [],
            times: [],
            message: null,
            message2: null,
            showresults: false,
            ready: false,
            timeout: false,
            level,
        });

        if (level) {
            setTimeout(() => {
                setState((prevState) => ({ ...prevState, timeout: true }));
            }, level.time * 1000);
        }
    };

    const handleComplete = (timereq) => {
        handleRate(timereq);
    };

    const {
        current,
        series,
        results,
        message,
        message2,
        showresults,
        timeout,
        level,
    } = state;

    const rate = results[current];
    const messagestyle = message ? (!rate ? ' error' : ' valid') : '';
    const percent = Math.round((current / series.length) * 100);
    const is_test = props.params.is_test ? props.params.is_test : false;


    if (!showresults) {
        if (!level) return null;

        return (
            <Row className="exercise">
                <BackMusic source={'random'} />

                {!is_test && (
                    <Col span={21} className="progress-bar">
                        <Progress percent={percent} showInfo={false} />
                    </Col>
                )}

                {!message && (
                    <Col span={24} className="exercise-body couple-body">
                        <ExerciseBlocker show={messagestyle} />
                        <section className="coupleschall">
                            <article className="couples">
                                {!message && (
                                    <Couples
                                        key={current}
                                        showBack={timeout}
                                        items={level.items}
                                        beads={level.beads}
                                        onComplete={handleComplete}
                                    />
                                )}
                            </article>
                            {!timeout && (
                                <article className="clock">
                                    <img src="./static/utils/clock.gif" alt="clock" />
                                </article>
                            )}
                        </section>
                    </Col>
                )}

                <Col span={24}>
                    <Row className={`botones coupleschall${messagestyle}`}>
                        <Col span={24} className="message">
                            {message}
                        </Col>
                        {message && (
                            <Col span={24}>
                                <Button
                                    key="submit"
                                    type="primary"
                                    onClick={handleNext}
                                    style={{ width: '90%' }}
                                >
                                    {t(props.lang, 'next')}
                                </Button>
                            </Col>
                        )}
                        {message2 && (
                            <Col span={24} className="message">
                                {message2}
                            </Col>
                        )}
                    </Row>
                </Col>
            </Row>
        );
    } else {
        const params = { ...props.params, num: series.length, show_time: true };

        return (
            <Result
                params={params}
                results={results}
                handleRepeat={handleRepeat}
                handleCancel={props.handleCancel}
                lang={props.lang}
            />
        );
    }
};

export default CouplesChall;